/** Wahlabend: Prognose und Hochrechnung bauen sich auf, danach Gewinne/Verluste und mögliche Mehrheiten. */
import { useEffect, useState } from 'react';
import { useS } from '../store/game';
import { PARTIES } from '../content/parties';
import { NEED } from '../content/consts';
import { PA, PC } from '../engine/rules';
import { de } from '../engine/util';

const shown = new Set<string>();
const DUR = 2600;
const ease = (t: number) => 1 - Math.pow(1 - t, 3);

export function Hochrechnung() {
  const S: any = useS();
  const key = `${S.seed}-${S.leg}-${S.elYear}`;
  const reduce = typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  const [p, setP] = useState(() => (shown.has(key) || reduce ? 1 : 0));
  useEffect(() => {
    if (p >= 1) { shown.add(key); return; }
    let raf = 0; const t0 = performance.now();
    const step = (t: number) => { const q = Math.min(1, (t - t0) / DUR); setP(q); if (q < 1) raf = requestAnimationFrame(step); else shown.add(key); };
    raf = requestAnimationFrame(step); return () => cancelAnimationFrame(raf);
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps
  const res = S.res; if (!res) return null;
  const prev = S.resPrev?.share as Record<string, number> | undefined;
  const ids = ['YOU', ...Object.keys(PARTIES)].filter((id) => res.share[id] != null).sort((a, b) => res.share[b] - res.share[a]);
  const top = Math.max(...ids.map((id) => res.share[id]));
  const e = ease(p), done = p >= 1;
  const stage = p < .35 ? '18:00 Uhr · Prognose' : p < .8 ? 'Hochrechnung' : done ? 'Vorläufiges Endergebnis' : 'Hochrechnung';
  const before = (id: string) => (prev ? prev[id] ?? 0 : id === 'YOU' ? 0 : PARTIES[id].base);
  // mögliche Mehrheiten mit der eigenen Partei
  const others = res.inP.filter((id: string) => id !== 'YOU');
  const combos: { ids: string[]; seats: number }[] = [];
  for (let i = 0; i < others.length; i++) {
    const a = others[i], s1 = res.seats.YOU + res.seats[a];
    if (s1 >= NEED) combos.push({ ids: ['YOU', a], seats: s1 });
    else for (let j = i + 1; j < others.length; j++) { const b = others[j], s2 = s1 + res.seats[b]; if (s2 >= NEED) combos.push({ ids: ['YOU', a, b], seats: s2 }); }
  }
  combos.sort((x, y) => x.ids.length - y.ids.length || y.seats - x.seats);
  return (
    <div className="hoch" aria-live="polite">
      <div className="hoch-h"><span className="label">{stage}</span>{!done && <span className="hoch-dot" aria-hidden="true" />}</div>
      <div className="hoch-cols" role="img" aria-label={`Ergebnis: ${ids.map((id) => `${PA(id)} ${de(res.share[id])} %`).join(', ')}`}>
        {ids.map((id) => { const v = res.share[id] * e, d = res.share[id] - before(id); return (
          <div className="hc" key={id}>
            <b className="num">{de(v)}</b>
            <div className="hc-bar"><i style={{ height: `${(v / top) * 100}%`, background: PC(id) }} /></div>
            <span className="hc-n">{PA(id)}</span>
            <span className={'num hc-d ' + (d > .05 ? 'up' : d < -.05 ? 'down' : '')} style={{ opacity: done ? 1 : 0 }}>{prev || id !== 'YOU' ? `${d > 0 ? '+' : d < 0 ? '−' : '±'}${de(Math.abs(d))}` : 'neu'}</span>
          </div>); })}
      </div>
      {done && <div className="hoch-combo"><span className="label">Mögliche Mehrheiten · nötig {NEED} von 630</span>
        <div className="tags">{res.seats.YOU >= NEED && <span className="tag up">{PA('YOU')} allein · {res.seats.YOU}</span>}
          {combos.slice(0, 5).map((c) => <span className="tag" key={c.ids.join()}>{c.ids.map((id) => <i key={id} className="sw" style={{ background: PC(id) }} />)}{c.ids.map(PA).join(' + ')} · {c.seats}</span>)}
          {!combos.length && res.seats.YOU < NEED && <span className="sub">Keine Mehrheit mit höchstens zwei Partnern. Denk an eine Minderheitsregierung.</span>}</div></div>}
    </div>
  );
}
